<div class="bg-primary h-100 w-100 row g-0 justify-content-center">
  <div class="col-auto align-self-center">
    <div class="logo text-center py-5">
      <era-pair-code-input-ui></era-pair-code-input-ui>
    </div>
  </div>
</div>